import Vue from 'vue'

Vue.filter('NumberFormat', function (value) {
  if (!value) {
    return '0'
  }
  const intPartFormat = value.toString().replace(/(\d)(?=(?:\d{3})+$)/g, '$1,') // 将整数部分逢三一断
  return intPartFormat
})

Vue.filter('imgFilter', function (value, size) {
  if (!value) return
  let url = 'https://dike-version.oss-cn-hongkong.aliyuncs.com/'
  let oss = '?x-oss-process=image/resize,l_' + size
  return value.startsWith('http') ? (size ? value + oss : value) : (size ? url + value + oss : url + value)
})

Vue.filter('substring', function (value, begin, end) {
  return value.substring(begin, end)
})



// WEBPACK FOOTER //
// ./src/utils/filter.js